import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../lib/api';

export function ForgotPassword(){
  const [email,setEmail] = useState('');
  const [sent,setSent] = useState(false);
  const [token,setToken] = useState('');
  const [error,setError] = useState<string| null>(null);
  const [loading,setLoading] = useState(false);

  async function handle(e:React.FormEvent){
    e.preventDefault(); setError(null); setLoading(true);
    try { const r = await api.forgot(email); setSent(true); if(r.token) setToken(r.token); } catch(err:any){ setError(err.message);} finally { setLoading(false);} }

  return (
    <AuthShell title="Recuperar Senha">
      <form onSubmit={handle} className="space-y-4">
        <div>
          <label className="block text-xs font-medium mb-1">Email</label>
          <input value={email} onChange={e=>setEmail(e.target.value)} type="email" required className="w-full bg-slate-900/60 border border-slate-700 rounded px-3 py-2 text-sm focus:ring-2 focus:ring-brand-500 outline-none" />
        </div>
        {error && <p className="text-xs text-red-400">{error}</p>}
        {sent && <p className="text-xs text-emerald-400">Se existir conta enviaremos instruções. Token (dev): {token || '—'}</p>}
        <button disabled={loading} className="w-full h-10 rounded bg-brand-500 hover:bg-brand-400 text-white text-sm font-semibold disabled:opacity-60">{loading? 'Enviando...' : 'Enviar Link'}</button>
        <div className="flex justify-between text-[11px] text-slate-400">
          <Link to="/login" className="hover:text-slate-200">Voltar ao Login</Link>
        </div>
      </form>
    </AuthShell>
  );
}

function AuthShell({children,title}:{children:React.ReactNode; title:string}){
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-slate-950 to-slate-900 px-4">
      <div className="w-full max-w-sm bg-slate-950/80 border border-slate-800 rounded-xl p-8 shadow-xl">
        <h1 className="text-xl font-semibold text-slate-100 mb-6">{title}</h1>
        {children}
      </div>
    </div>
  );
}
